import { Button } from '@airtm/airtm-ui';
import { useTranslation, Trans } from 'react-i18next';
import { CUSTODIAL_PROVIDERS, LOCAL_STORAGE } from '@constants';
import { useHistory } from 'react-router-dom';

type ConnectToBridgeProps = {
  readonly onContinue: () => void;
  readonly onBack: () => void;
};
function ConnectToBridge(props: ConnectToBridgeProps) {
  const { t } = useTranslation(['ENTERPRISE_SIGNUP']);
  const history = useHistory();
  const { onContinue, onBack } = props;

  const configure = () => {
    onContinue();
    localStorage.setItem(LOCAL_STORAGE.SELECTED_CUSTODIAL_PROVIDER, CUSTODIAL_PROVIDERS.BRIDGE);
    history.push('/settings/custodial-service');
  };
  return (
    <div className="mb-5 mt-9">
      <h1>{t('CONNECT_PROVIDER_TITLE_BRIDGE')}</h1>
      <h5 className="font-weight--regular text--headings my-5">
        <Trans i18nKey="ENTERPRISE_SIGNUP:BRIDGE_CREATE_ACCOUNT_DESCRIPTION" />
      </h5>
      <div className="d-flex flex-gap-32 mt-5">
        <Button variant="secondary" onClick={onBack}>
          {t('BACK')}
        </Button>
        <Button onClick={configure}>{t('STATIC:CONTINUE')}</Button>
      </div>
    </div>
  );
}

export default ConnectToBridge;
